import { Button ,Form, FloatingLabel, } from "react-bootstrap"
import { DataGrid } from "@mui/x-data-grid";
import { GridToolbar } from "@mui/x-data-grid";


const BatchInvoice = () =>{    
    const columns = [
     
        {
            field: "Select",
            headerName: "Select",
            sortable: false,
            width: 200,
            disableClickEventBubbling: true,
            renderCell: (data) => {
          
      
              return (
                <>
                  <>
                    <div className="action_btn">
                      <div className="floating-checbox">
                                    <div className="form-check form-check-inline">
                                      <input className="form-check-input" type="checkbox" id="inlineCheckbox1" value="CWT" name="RateType" />
                                      <label className="form-check-label" htmlFor="inlineCheckbox1"></label>
                                    </div>
                                  </div>
                    </div>
                  </>
                </>
              )
      
            },
          },
        { field: "InvoiceCycle", headerName: "InvoiceCycle", width: 280 },
        { field: "Invoices", headerName: "Invoices", width: 280 },
        { field: "WIP", headerName: "WIP", width: 280 },
        { field: "Orders", headerName: "Orders", width: 280 },
        { field: "LastDate", headerName: "LastDate", width: 280 }
    ];

    const rows = [
        { id: 1, InvoiceCycle: 'Bombard', Invoices: '11', WIP: "325.23", Orders: "45", LastDate: "20/10/2023" },
    ];

    // Previously Processed inovice
    const column = [
     
        {
            field: "Select",
            headerName: "Select",
            sortable: false,
            width: 200,
            disableClickEventBubbling: true,
            renderCell: (data) => {
          
      
              return (
                <>
                  <>
                    <div className="action_btn">
                      <div className="floating-checbox">
                                    <div className="form-check form-check-inline">
                                      <input className="form-check-input" type="checkbox" id="inlineCheckbox1" value="CWT" name="RateType" />
                                      <label className="form-check-label" htmlFor="inlineCheckbox1"></label>
                                    </div>
                                  </div>
                    </div>
                  </>
                </>
              )
      
            },
          },
        { field: "Batch", headerName: "Batch", width: 200 },
        { field: "Cycle", headerName: "Cycle", width: 200 },
        { field: "Invoicedate", headerName: "Invoicedate", width: 200 },
        { field: "Process", headerName: "Process", width: 200 },
        { field: "Start", headerName: "Start", width: 200 },
        { field: "End", headerName: "End", width: 200 },
        { field: "Total", headerName: "Total", width: 200 }
    ];

    const row = [
        { id: 1, Batch: '20532', Cycle: 'Bombard', Invoicedate: "22/10/2022", Process: "01/11/2022", Start: "20/10/2023" , End: "20/10/2023", Total : "1450.00"},
    ];

    return(
        <>
        <div className="invoice-date">
             <Form.Group controlId="accountnumber" className="mb-2">
                        <FloatingLabel controlId="floatingInput" label="Invoice Date">
                            <Form.Control type="date" placeholder="Account Name" name="AccountName" value="" />
                        </FloatingLabel>
                    </Form.Group>
                    <div className="invoice-btn">
                    <Button>Create Invoice</Button>
                    </div>
        </div>
        {/* Invoice Cycle */}
        <div className="user-role-table " style={{ height: "400px" }}>
        <h6>Choose an invoice cycle to process</h6>
        <DataGrid rows={rows} columns={columns} pageSize={10} rowsPerPageOptions={[1]} components={{ Toolbar: GridToolbar }} />
      </div>
      {/* Previously Inovides */}
      <div className="user-role-table " style={{ height: "400px" }}>
        <h6>List of Previously processed & not posted inovice batches</h6>
        <DataGrid rows={row} columns={column} pageSize={10} rowsPerPageOptions={[1]} components={{ Toolbar: GridToolbar }} />
      </div>
        </>
    )
}
export default BatchInvoice